import React from 'react';
import EventsPortal from '../portal/EventsPortal';
import { SCHOOL_OF_COMPETENCE_PORTAL } from '../portal/portalConfigs';

const SchoolOfCompetence = () => <EventsPortal config={SCHOOL_OF_COMPETENCE_PORTAL} />;

export default SchoolOfCompetence;
